import { render, staticRenderFns } from "./ElForm.vue?vue&type=template&id=68beb9a8&"
import script from "./ElForm.vue?vue&type=script&lang=js&"
export * from "./ElForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68beb9a8')) {
      api.createRecord('68beb9a8', component.options)
    } else {
      api.reload('68beb9a8', component.options)
    }
    module.hot.accept("./ElForm.vue?vue&type=template&id=68beb9a8&", function () {
      api.rerender('68beb9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/forms/elements/ElForm.vue"
export default component.exports